import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRCodeDisplay = ({ data, size = 256 }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  useEffect(() => {
    QRCode.toDataURL(data, { width: size })
      .then(url => setQrCodeUrl(url))
      .catch(err => console.error('QR Code generation error:', err));
  }, [data, size]);

  return (
    <div className="flex flex-col items-center">
      {qrCodeUrl && (
        <img
          src={qrCodeUrl}
          alt="QR Code"
          className="border-2 border-gray-300 rounded-lg"
          style={{ width: size, height: size }}
        />
      )}
    </div>
  );
};

export default QRCodeDisplay;
